(function () {

  /* ---- State ---- */
  var currentTab = 'delivery';

  /* ---- Mark popup as seen + hide it (called on close, outside-click, or submit) ---- */
  window.otpHidePopup = function () {
    var overlay = document.getElementById('otp-overlay');
    if (overlay) overlay.classList.add('otp-hidden');
    try {
      sessionStorage.setItem('otp_popup_seen', 'true');
    } catch (e) {}
    var teaserEl = document.getElementById('otp-teaser');
    if (teaserEl) teaserEl.style.display = 'flex';
  };

  /* ---- Tab Switcher ---- */
  window.otpSwitchTab = function (tab) {
    currentTab = tab;
    document.getElementById('panel-delivery').classList.toggle('otp-panel--hidden', tab !== 'delivery');
    document.getElementById('panel-pickup').classList.toggle('otp-panel--hidden',  tab !== 'pickup');
    document.getElementById('tab-delivery').classList.toggle('otp-tab--active', tab === 'delivery');
    document.getElementById('tab-pickup').classList.toggle('otp-tab--active',  tab === 'pickup');
    document.getElementById('tab-delivery').setAttribute('aria-selected', tab === 'delivery');
    document.getElementById('tab-pickup').setAttribute('aria-selected',  tab === 'pickup');
    document.getElementById('otp-error').textContent = '';
  };

  /* ---- Phone formatter (03xx-xxxxxxx) ---- */
  window.otpFormatPhone = function (input) {
    var v = input.value.replace(/\D/g, '');
    if (v.length > 4) v = v.slice(0, 4) + '-' + v.slice(4, 11);
    input.value = v;
  };

  /* ---- Update outlet address info (Pick-Up) ---- */
  window.otpUpdateOutletInfo = function () {
    var sel      = document.getElementById('pickup-outlet');
    var info     = document.getElementById('outlet-info');
    var addrText = document.getElementById('outlet-address-text');
    var dirLink  = document.getElementById('outlet-directions-link');

    if (!sel.value) {
      info.style.display = 'none';
      return;
    }

    var parts      = sel.value.split('|');
    var address    = parts[1] || '';
    var mapsUrl    = parts[2] || '';

    addrText.textContent = address;
    dirLink.href = mapsUrl || ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address));
    info.style.display = 'flex';
  };

  /* ---- Delivery info ---- */
  window.otpUpdateDeliveryInfo = function () {
    // placeholder for future use
  };

  /* ---- Validate & Submit ---- */
  window.otpSubmit = function () {
    var errEl = document.getElementById('otp-error');
    errEl.textContent = '';

    var phone, location, outletName, outletAddress, customerAddress;

    if (currentTab === 'delivery') {
      location        = document.getElementById('delivery-location').value;
      customerAddress = document.getElementById('delivery-address').value.trim();
      phone           = document.getElementById('delivery-phone').value.replace(/\D/g, '');

      if (!location)         { errEl.textContent = '{{ section.settings.err_location }}';        return; }
      if (!customerAddress)  { errEl.textContent = '{{ section.settings.err_address }}';         return; }
      if (phone.length < 10) { errEl.textContent = '{{ section.settings.err_phone }}';           return; }

    } else {
      var outletSel   = document.getElementById('pickup-outlet').value;
      customerAddress = document.getElementById('pickup-address').value.trim();
      phone           = document.getElementById('pickup-phone').value.replace(/\D/g, '');

      if (!outletSel)        { errEl.textContent = '{{ section.settings.err_outlet }}';          return; }
      if (!customerAddress)  { errEl.textContent = '{{ section.settings.err_address }}';         return; }
      if (phone.length < 10) { errEl.textContent = '{{ section.settings.err_phone }}';           return; }

      var parts      = outletSel.split('|');
      outletName     = parts[0];
      outletAddress  = parts[1] || '';
    }

    /* ---- Build cart note ---- */
    var noteLines = [];
    noteLines.push('Order Type: ' + (currentTab === 'delivery' ? 'Delivery' : 'Pick-Up'));
    if (currentTab === 'delivery') {
      noteLines.push('Delivery Location: ' + location);
      noteLines.push('Customer Address: ' + customerAddress);
    } else {
      noteLines.push('Pick-Up Outlet: ' + outletName);
      noteLines.push('Outlet Address: ' + outletAddress);
      noteLines.push('Customer Address: ' + customerAddress);   /* FIX: was missing in pickup */
    }
    noteLines.push('Contact: ' + document.getElementById(currentTab === 'delivery' ? 'delivery-phone' : 'pickup-phone').value);

    var noteString = noteLines.join('\n');

    /* ---- Save to Shopify cart (note + attributes) ---- */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: noteString,
        attributes: {
          'Order Type':      currentTab === 'delivery' ? 'Delivery' : 'Pick-Up',
          'Location':        currentTab === 'delivery' ? location : outletName,
          'Outlet Address':  outletAddress  || '',
          'Customer Address': customerAddress,
          'Contact':         document.getElementById(currentTab === 'delivery' ? 'delivery-phone' : 'pickup-phone').value
        }
      })
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      try {
        sessionStorage.setItem('otp_order_type', currentTab === 'delivery' ? 'Delivery' : 'Pick-Up');
        sessionStorage.setItem('otp_location',   currentTab === 'delivery' ? location : outletName);
        sessionStorage.setItem('otp_phone',      document.getElementById(currentTab === 'delivery' ? 'delivery-phone' : 'pickup-phone').value);
      } catch(e) {}
      otpHidePopup();
    })
    .catch(function (err) {
      console.error('Cart update failed:', err);
      otpHidePopup();
    });
  };

  /* ---- Use current location (shared by delivery + pickup buttons) ---- */
  window.otpUseCurrentLocation = function (targetFieldId, btnId) {
    var errEl = document.getElementById('otp-error');
    errEl.textContent = ''; // hide any previous error immediately on retry

    var btn = document.getElementById(btnId);
    if (!btn) {
      console.error('otpUseCurrentLocation: button id "' + btnId + '" not found');
      return;
    }
    var btnText = btn.querySelector('.otp-locate-btn-text');
    var targetField = document.getElementById(targetFieldId);
    if (!targetField) {
      console.error('otpUseCurrentLocation: target field id "' + targetFieldId + '" not found');
      return;
    }

    if (!navigator.geolocation) {
      errEl.textContent = 'Location detection is not supported by your browser.';
      return;
    }

    var originalText = btnText ? btnText.textContent : '';
    btn.disabled = true;
    if (btnText) btnText.textContent = 'Detecting location...';

    navigator.geolocation.getCurrentPosition(
      function (position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;

        fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lng + '&zoom=18&addressdetails=1')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var address = data.display_name || (lat.toFixed(6) + ', ' + lng.toFixed(6));
            targetField.value = address;
            errEl.textContent = ''; // field filled successfully -> make sure alert is hidden
          })
          .catch(function () {
            targetField.value = lat.toFixed(6) + ', ' + lng.toFixed(6);
            errEl.textContent = '';
          })
          .finally(function () {
            btn.disabled = false;
            if (btnText) btnText.textContent = originalText;
          });
      },
      function (error) {
        btn.disabled = false;
        if (btnText) btnText.textContent = originalText;
        errEl.textContent = (error.code === error.PERMISSION_DENIED)
          ? 'Location permission denied. Please enter your address manually.'
          : 'Could not detect your location. Please enter it manually.';
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  /* ---- Everything below runs once the DOM is guaranteed ready.
     This avoids the popup silently failing to auto-show if this
     script happens to execute before #otp-overlay exists. ---- */
  function otpInit() {
    var overlay  = document.getElementById('otp-overlay');
    var teaserEl = document.getElementById('otp-teaser');

    if (!overlay) {
      console.error('otp-overlay not found in DOM — popup cannot initialize');
      return;
    }

    /* ---- Close on outside (overlay backdrop) click ---- */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) otpHidePopup();
    });

    /* ---- Auto-show only if never seen this store session ---- */
    try {
      var seen = sessionStorage.getItem('otp_popup_seen');
      if (!seen) {
        overlay.classList.remove('otp-hidden');
        if (teaserEl) teaserEl.style.display = 'none';
      } else {
        overlay.classList.add('otp-hidden');
        if (teaserEl) teaserEl.style.display = 'flex';
      }
    } catch (e) {
      overlay.classList.remove('otp-hidden');
      if (teaserEl) teaserEl.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', otpInit);
  } else {
    otpInit();
  }

})();
